const SESSION_STORAGE_PREFIX = 'anchor-scroll_';

export { SESSION_STORAGE_PREFIX };
